export function openLinkInNewWindow(link: string) {
  if (link) {
    window.open(link, '_blank')?.focus();
  }
}
